import { render, staticRenderFns } from "./StaffCreateRequestModal.vue?vue&type=template&id=03f74f23&scoped=true&lang=pug"
import script from "./StaffCreateRequestModal.vue?vue&type=script&lang=js"
export * from "./StaffCreateRequestModal.vue?vue&type=script&lang=js"
import style0 from "./StaffCreateRequestModal.vue?vue&type=style&index=0&id=03f74f23&prod&lang=css"
import style1 from "./StaffCreateRequestModal.vue?vue&type=style&index=1&id=03f74f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f74f23",
  null
  
)

export default component.exports